import styled, { css } from 'styled-components'
import { darken } from 'polished'

export const FormActions = styled.div`
  margin-top: 35px;
  padding: 10px 0px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  transition: all 0.3s ease;

  button {
    border-radius: ${props => props.theme.utils.radius.m}px;
    height: 60px;
    width: 100%;
    text-transform: lowercase;
    transition: all 0.3s ease;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);
    }

    &:active {
      transform: translateY(-1px);
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
    }

    &:first-letter {
      text-transform: uppercase;
    }
  }
`

export const FormControl = styled.form`
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  transition: all 0.3s ease;

  input {
    box-shadow: 0px 1px 4px 0px #0000001A;
    box-sizing: border-box;
    margin: 10px 0px;
    height: 50px;
    width: 100%;
    transition: all 0.3s ease;
    border-radius: 12px;

    &:hover:not(:disabled) {
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
      transform: translateY(-1px);
    }

    &:focus {
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
      transform: translateY(-1px);
    }

    &.internal_number,
    &.zipcode {
      flex: auto;
    }

    &::placeholder{
      color: #CBCBCB;
      transition: all 0.3s ease;
    }

    &:focus::placeholder {
      opacity: 0.7;
    }
  }

  textarea {
    box-shadow: 0px 1px 4px 0px #0000001A;
    width: 100%;
    margin: 10px 0 20px;
    border-radius: ${props => props?.theme?.utils?.radius?.s}px;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
      transform: translateY(-1px);
    }

    &:focus {
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
      transform: translateY(-1px);
    }
  }

  .input-autocomplete {
    width: 100%;
    background: #FFF;
    border: 0px solid #BBB;
    border-radius: 30px;
    font-size: 16px;
    padding: 12px 20px !important;
    height: 50px;
    outline: none;
    transition: all 0.3s ease;
    box-shadow: 0px 1px 4px 0px #0000001A;

    &:hover:not(:disabled) {
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
      transform: translateY(-1px);
    }

    &:focus {
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
      transform: translateY(-1px);
      border-color: ${() => darken(0.07, '#CCC')};
    }

    ::placeholder {
      color: #DBDCDB;
      transition: all 0.3s ease;
    }

    &:focus::placeholder {
      opacity: 0.7;
    }

    &:-ms-input-placeholder {
      color: #DBDCDB;
    }

    &::-ms-input-placeholder { /* Microsoft Edge */
      color: #DBDCDB;
    }
  }

  .google-control {
    transition: all 0.3s ease;

    .gps-button {
      border-radius: ${props => props?.theme?.utils?.radius?.m}px;
      transition: all 0.3s ease;
      background: transparent;

      &:hover {
        transform: translateY(-2px) scale(1.05);
      }

      &:active {
        transform: translateY(-1px) scale(1.02);
      }
    }

    input {
      border-radius: ${props => props?.theme?.utils?.radius?.s}px;
      box-shadow: 0px 1px 4px 0px #0000001A;
      transition: all 0.3s ease;

      &:hover:not(:disabled) {
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
        transform: translateY(-1px);
      }

      &:focus {
        border: 0px solid ${props => props.theme.colors.primary};
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
        transform: translateY(-1px);
      }
    }
  }

  .internal_number {
    width: 100%;

    & + .zipcode {
      width: 45%;
    }

    &:has(+ .zipcode) {
      width: 45%;
      ${props => props.theme?.rtl
        ? css`
            margin-left: 15px;
          `
        : css`
            margin-right: 15px;
          `}
    }
  }

  .zipcode {
    width: 100%;
  }

  @media (min-width: 481px) {
    padding: 10px;
  }
`

export const AddressWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-top: -11px;
  transition: all 0.3s ease;

  button {
    height: 41px;
    right: 1px;
    border: none;
    transition: all 0.3s ease;

    ${props => props.theme?.rtl && css`
      left: 1px;
      right: initial;
    `}

    svg {
      font-size: 18px;
      transition: all 0.3s ease;
    }

    &:hover svg {
      transform: scale(1.1);
    }
  }
`

export const WrapAddressInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  transition: all 0.3s ease;

  i {
    padding: 0px 10px;
    transition: all 0.3s ease;
  }

  svg {
    position: absolute;
    color: ${props => props.theme.colors.primary};
    top: 21px;
    left: 10px;
    font-size: 20px;
    transition: all 0.3s ease;
    ${props => props.theme?.rtl && css`
      right: 10px;
      left: initial;
    `}
  }

  input {
    background-position: left 10px center !important;
    background-repeat: no-repeat !important;
    background-size: 13px !important;
    padding: 7px 30px 7px 15px !important;
    transition: all 0.3s ease;
    ${props => props.theme?.rtl && css`
      padding: 7px 15px 7px 30px !important;
    `}
  }
`

export const AddressTagSection = styled.div`
  width: 100%;
  margin: 10px 0px;
  display: flex;
  justify-content: space-between;
  transition: all 0.3s ease;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    padding-left: 12px;
    padding-right: 12px;
    border: none;
    color: #D8D8D8;
    font-weight: 600;
    background-color: ${props => props.theme.colors.gray300};
    border-radius: ${props => props.theme.utils.radius.s}px;
    transition: all 0.3s ease;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
      background-color: ${props => props.theme.colors.gray200};
    }

    &:active {
      transform: translateY(-1px);
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
    }

    img {
      width: 25px;
      height: 25px;
      transition: all 0.3s ease;
    }

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
      transition: all 0.3s ease;

      svg {
        font-size: 30px;
        transition: all 0.3s ease;
      }
    }

    &:hover span {
      color: ${props => props.theme.colors.primary};
    }
  }

  button.active {
    color: ${props => props.theme.colors.darkGreen};
    background-color: ${props => props.theme.colors.lightGreen};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.2);
    }
  }
`

export const AddressTagsDivider = styled.div`
  width: 100%;
  display: flex;
  margin: 10px 5px;
  border-top: 2px solid #E9ECEF;
  transition: all 0.3s ease;

  p {
    margin-bottom: 0px;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  &:hover p {
    color: ${props => props.theme?.colors?.primary || '#000'};
  }
`

export const WrapperMap = styled.div`
  width: 100%;
  height: 170px;
  margin-bottom: 10px;
  transition: all 0.3s ease;

  > div {
    position: relative !important;
    width: 100% !important;
    height: 100% !important;
    border-radius: ${props => props?.theme?.utils?.radius?.m}px;
    transition: all 0.3s ease;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
`

export const WrapperSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  padding: 9px 10px;
  transition: all 0.3s ease;

  span {
    width: 100%;
    transition: all 0.3s ease;
  }
`
